import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";

export default function Layout({ children }) {
  return (
    <SmoothScroll>
      <div className="min-h-screen bg-ink-950 text-bone-50 relative">
        <div className="grain-overlay" aria-hidden />
        <Header />
        <main className="site-shell relative z-10">{children}</main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
